module.exports = __webpack_public_path__ + "main/assets/public/player/play-icon.e5eb942ce558233a.svg";